<ion-button
  [fill]="!variant ? 'solid' : variant"
  [class]="class"
  [style]="style"
  [type]="type"
  mode="ios"
  [color]="color"
  [expand]="expand"
  [size]="size"
>
  <ng-content></ng-content>
</ion-button>
